import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, tap, switchMap } from 'rxjs/operators';
import { SoftBanService } from 'src/app/shared/services/soft-ban.service';
import { SoftBanActions } from 'src/app/core/state/slices/soft-ban/soft-ban.actions';
import { Action } from '@ngrx/store';

@Injectable({ providedIn: 'root' })
export class SoftBanEffects implements OnInitEffects {
  /**
   * Effect for querying soft ban status from the GraphQL API.
   */
  getSoftBanStatus = createEffect(() =>
    this.actions$.pipe(
      ofType(SoftBanActions.getStatus),
      switchMap(() =>
        this.softBanService.getSoftBanStatus$().pipe(
          map((status) => SoftBanActions.setStatus({ trigger: 'SoftBanEffects', status })),
          catchError(() => of(SoftBanActions.setStatus({ trigger: 'SoftBanEffects', status: false }))),
          // If API call failed, set soft-ban status to false
          // this initializes soft-ban state as well.
        ),
      ),
    ),
  );

  /**
   * Effect for subscribing to action cable soft ban status updates.
   */
  initSoftBanFeature = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SoftBanActions.initState),
        tap(() => this.softBanService.initSoftBanFeature()),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private softBanService: SoftBanService,
  ) {}

  /**
   * Similar to ngOnInit - Performs initialisation of Soft Ban Feature.
   * Subscribes to action cable changes and runs soft ban query against BE.
   */
  ngrxOnInitEffects(): Action {
    return SoftBanActions.initState();
  }
}
